import uniqueId from 'lodash.uniqueid';
import { CordovaPlugins } from '../../../shared/CordovaPlugins';
import { isWeb } from '../../../shared/utils/is';

const LOCAL_NAMING_PREFIX = 'zp-'; // @note this is used when saved to s3, not just locally

export const createUUID = () => `${Date.now()}-${uniqueId()}`;

export const resolveLocalUri = (path) =>
    new Promise((resolve) => {
        CordovaPlugins().resolveLocalFileSystemURL(
            path,
            (result) => {
                resolve([null, result]);
            },
            (error) => {
                resolve([error, null]);
            }
        );
    });

export const resolveLocalUriAsBlob = (path, mimetype) =>
    new Promise((resolve, reject) => {
        CordovaPlugins().resolveLocalFileSystemURL(
            path,
            (fileEntry) => {
                fileEntry.file((file) => {
                    const reader = new FileReader();

                    reader.onloadend = function () {
                        resolve(new Blob([new Uint8Array(this.result)], { type: mimetype }));
                    };

                    reader.readAsArrayBuffer(file);
                });
            },
            reject
        );
    });

export const removeLocalFile = async (filename) => {
    if (isWeb()) {
        return new Promise((resolve) => {
            resolve();
        });
    }

    const [, file] = await resolveLocalUri(`${CordovaPlugins().file.dataDirectory}${filename}`);

    return new Promise((resolve) => {
        if (!file) {
            resolve();
            return;
        }

        file.remove(resolve);
    });
};

export const getFileExtension = (filename, mimetype) => {
    // content URLs sometimes contain '.' that aren't an extension
    if (!filename.startsWith('content://') && filename.includes('.')) {
        return `.${filename.split('.').pop()}`;
    }

    // Android content:// URIs won't include a file extension, so we need to determine it from the mimetype
    if (mimetype) {
        return `.${mimetype.split('/').pop()}`;
    }

    return '';
};

/**
 * In some cases (both for Android and iOS but in different cases) we need to copy media files to our
 * directory for security, ability to rotate, etc.
 */
export const copyFileToAppDirectory = async (filename, mimetype) => {
    const fileExtension = getFileExtension(filename, mimetype);
    const newFilename = `${LOCAL_NAMING_PREFIX}${createUUID()}${fileExtension}`;

    const [targetDirError, targetDir] = await resolveLocalUri(CordovaPlugins().file.dataDirectory);

    if (targetDirError) {
        return new Promise((resolve) => {
            resolve([targetDirError, null]);
        });
    }

    const [existingFileError, existingFile] = await resolveLocalUri(filename);

    if (existingFileError) {
        return new Promise((resolve) => {
            resolve([existingFileError, null]);
        });
    }

    return new Promise((resolve) => {
        existingFile.copyTo(
            targetDir,
            newFilename,
            (newFile) => {
                resolve([null, newFile]);
            },
            (error) => {
                resolve([error, null]);
            }
        );
    });
};
